import type { FC, SVGProps } from 'react';

const IconBasket: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.33398 8.43338L7.33398 5.8282C7.33398 4.24872 8.50732 3.30005 9.90065 3.30005H12.1007C13.5673 3.30005 14.6673 4.24872 14.6673 5.8282V8.43338'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.3338 6.9668H3.66699V16.2802C3.66699 17.7667 4.62996 19.0302 5.88924 19.0302H16.1116C17.3708 19.0302 18.3338 17.841 18.3338 16.2802V6.9668Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default IconBasket;
